import React from "react";
import Dashboard from "../../components/Dashboard";

const PatientResultReport = () => {
  return <Dashboard>PatientResultReport</Dashboard>;
};

export default PatientResultReport;
